import queryString from 'query-string';
import { Navigate, Outlet, useLocation } from 'react-router';

const ProtectedRoute = ({ isAllowed, redirectPath, children = null }) => {
  const location = useLocation();

  if (!isAllowed) {
    if (redirectPath === '/login') {
      const from = queryString.stringify({ from: location.pathname + location.search });
      redirectPath = `${redirectPath}?${from}`;
    }

    const search = queryString.parse(location.search);
    if (search.from) {
      redirectPath = search.from;
    }

    return <Navigate to={redirectPath} replace />;
  }

  if (!children) {
    return <Outlet />;
  }

  return children;
};

export default ProtectedRoute;
